<template>
  <div class="w-full">

    <div id="seccionImprimir2" class="contenedor-cert">
      <img src="../../../assets/images/seminarios/diploma2.jpg" class="diploma-bg">

      <!-- Contenedor central de referencia -->
      <div class="contenido-central">

        <!-- Nombre del participante -->
        <div class="nombre-participante">
          <span class="a-prefijo">A:</span>
          {{ usuario.nombres }} {{ usuario.apellidos }}
        </div>

        <!-- Texto "Por su exitosa participación en:" -->
        <div class="texto-exitoso">
          Por su exitosa participación en:
        </div>

        <!-- Título de la capacitación -->
        <div class="titulo-capacitacion">
          {{ titlecase(nombreCapacitacion || encuesta.titulo) }}
        </div>

        <!-- Fecha - Ahora dentro del mismo contenedor -->
        <div class="fecha-certificado">
          {{ fechaFin }}
        </div>

      </div>

      <!-- Firma del Capacitador -->
      <div v-if="firmaCapacitador" class="firma-container">
        <img :src="$data_url + 'archivos/usuarios/firmas/' + firmaCapacitador" alt="Firma Capacitador" class="firma-img">
      </div>
    </div>

    <vs-popup title="Sigue estos pasos para descargar tu certificado" :active.sync="popupActivo">
      <img src="../../../assets/images/seminarios/tutorialDescarga.png" style="width: 100%;"><br><br>
      <vs-button color="primary" class="w-full mb-1" type="gradient" @click="descargarCertificado()">Descargar</vs-button>
    </vs-popup>

  </div>
</template>

<script>
export default {
  data() {
    return {
      popupActivo: false,
      usuario: { nombres: '', apellidos: '' },
      encuesta: { titulo: '', codigo: '' },
      nombreCapacitacion: '',
      firmaCapacitador: null,
      fechaFin: ''
    }
  },
  computed: {
    fechaHoy() {
      const d = new Date()
      const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
        'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
      return `${d.getDate()} de ${meses[d.getMonth()]} de ${d.getFullYear()}`
    }
  },
  mounted() {
    try {
      const u = localStorage.getItem('userEncuestaProlipa')
      const e = localStorage.getItem('dataEncuestaCertificado')
      const n = localStorage.getItem('nombreEntidadEncuesta')
      const f = localStorage.getItem('firmaCapacitadorEncuesta')
      const ff = localStorage.getItem('fechaFinEncuesta')
      if (u) this.usuario = JSON.parse(u)
      if (e) this.encuesta = JSON.parse(e)
      if (n) this.nombreCapacitacion = n
      if (f) this.firmaCapacitador = f
      if (ff) this.fechaFin = ff
    } catch (err) { }
    this.valPopupDesc()
  },
  methods: {
    titlecase(value) {
      if (!value) return '';
      return value.toLowerCase().replace(/(?:^|\s)\S/g, function(char) {
        return char.toUpperCase();
      });
    },
    valPopupDesc() {
      setTimeout(() => {
        if (!this.popupActivo) {
          this.popupActivo = true
        }
      }, 3000)
    },
    descargarCertificado() {
      this.popupActivo = false
      const nombreArchivo = 'certificado_' + (this.encuesta.codigo || 'encuesta').replace('ENC_', 'CAP_')
      document.title = nombreArchivo

      try {
        const payload = {
          encuesta_id: this.encuesta.id,
          usuario_id: this.usuario.idusuario,
        }
        const asignacionId = localStorage.getItem('asignacionIdEncuesta')
        if (asignacionId) payload.asignacion_id = asignacionId

        this.$http.post(this.$server_url + 'encuesta_prolipa/registrar-descarga', payload)
          .catch(() => { })
      } catch (e) { }

      setTimeout(() => {
        window.print()
      }, 1000)
    }
  }
}
</script>

<style>
@font-face {
  font-family: "font_diploma";
  src: url("../../../assets/images/seminarios/SavoyePlain.otf");
}

/* Estilos base */
.contenedor-cert {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  background: #e0e0e0;
}

.diploma-bg {
  width: 100%;
  height: auto;
  max-width: 1280px;
  display: block;
  margin: 0 auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

/* Contenedor central de referencia - Con padding derecho de 200px */
.contenido-central {
  position: absolute;
  top: 56%;
  left: 53%;
  transform: translate(-50%, -50%);
  width: 85%;
  max-width: 900px;
  text-align: center;
  padding-right: 200px;
  box-sizing: border-box;
}

/* Nombre del participante */
.nombre-participante {
  font-weight: bold;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: clamp(18px, 4vw, 48px);
  text-align: center;
  white-space: normal;
  word-wrap: break-word;
  margin-bottom: 20px;
  color: #2c3e50;
  line-height: 1.3;
}

.a-prefijo {
  font-family: 'font_diploma', cursive;
  font-size: clamp(20px, 4.5vw, 50px);
}

/* Texto "Por su exitosa participación en:" */
.texto-exitoso {
  font-family: 'font_diploma', cursive;
  font-weight: 700;
  line-height: 1.2;
  font-size: clamp(16px, 3vw, 38px);
  text-align: center;
  margin-bottom: 15px;
  color: #1a1a1a;
  word-wrap: break-word;
}

/* Título de la capacitación */
.titulo-capacitacion {
  font-family: 'font_diploma', cursive;
  line-height: 1.3;
  font-size: clamp(14px, 2.8vw, 48px);
  text-align: center;
  word-wrap: break-word;
  color: #1a1a1a;
  padding: 0 10px;
  margin-bottom: 30px;
}

/* Fecha del certificado - Dentro del flujo normal */
.fecha-certificado {
  font-family: 'font_diploma', cursive;
  text-align: center;
  color: #333;
  margin-top: 20px;
  font-size: clamp(14px, 2.5vw, 30px);
  white-space: nowrap;
  padding-right: 0;

}

/* Contenedor de la firma - Posicionado desde el centro */
.firma-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(calc(-50% + 150px), calc(-50% + 275px));
  width: 180px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.firma-img {
  max-width: 100%;
  max-height: 80px;
  width: auto;
  height: auto;
  object-fit: contain;
}

/* Configuración de impresión A4 horizontal */
@page {
  size: A4 landscape;
  margin: 0;
}

@media print {
  body, html {
    margin: 0 !important;
    padding: 0 !important;
    width: 100%;
    height: 100%;
    background: white;
    overflow: hidden;
  }

  .w-full {
    width: 100%;
    height: 100vh;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  .contenedor-cert {
    position: relative;
    width: 100%;
    height: 100vh;
    min-height: 0;
    margin: 0;
    padding: 0;
    page-break-after: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .diploma-bg {
    width: 100%;
    height: auto;
    display: block;
    margin: 0;
    box-shadow: none;
  }

  .contenido-central {
    top: 52%;
    width: 80%;
    padding-right: 150px;
  }

  .nombre-participante {
    font-size: 28px;
    margin-bottom: 15px;
  }

  .a-prefijo {
    font-size: 30px;
  }

  .texto-exitoso {
    font-size: 24px;
    margin-bottom: 10px;
  }

  .titulo-capacitacion {
    font-size: 34px;
    margin-bottom: 20px;
  }

  .fecha-certificado {
    font-size: 20px;
    margin-top: 15px;
  }

  .firma-container {
    transform: translate(calc(-50% + 150px), calc(-50% + 275px));
    width: 180px;
  }

  .firma-img {
    max-height: 80px;
  }

  .vs-popup--background,
  .vs-popup--content {
    display: none !important;
  }
}

/* Responsive para tablets */
@media screen and (max-width: 1024px) and (min-width: 768px) {
  .contenido-central {
    width: 85%;
    top: 51%;
    padding-right: 150px;
  }

  .nombre-participante {
    margin-bottom: 15px;
  }

  .texto-exitoso {
    margin-bottom: 10px;
  }

  .titulo-capacitacion {
    margin-bottom: 25px;
  }

  .fecha-certificado {
    margin-top: 15px;
  }

  .firma-container {
    transform: translate(calc(-50% + 140px), calc(-50% + 265px));
    width: 160px;
  }
}

/* Responsive para móviles */
@media screen and (max-width: 767px) {
  .contenedor-cert {
    min-height: auto;
  }

  .contenido-central {
    top: 48%;
    width: 90%;
    padding-right: 100px;
  }

  .nombre-participante {
    margin-bottom: 10px;
  }

  .texto-exitoso {
    margin-bottom: 8px;
  }

  .titulo-capacitacion {
    margin-bottom: 20px;
  }

  .fecha-certificado {
    margin-top: 10px;
  }

  .firma-container {
    transform: translate(calc(-50% + 90px), calc(-50% + 230px));
    width: 100px;
    min-width: 60px;
  }

  .firma-img {
    max-height: 40px;
  }
}

/* Responsive para móviles pequeños */
@media screen and (max-width: 480px) {
  .contenido-central {
    top: 46%;
    width: 92%;
    padding-right: 60px;
  }

  .nombre-participante {
    margin-bottom: 8px;
  }

  .texto-exitoso {
    margin-bottom: 6px;
  }

  .titulo-capacitacion {
    margin-bottom: 15px;
  }

  .fecha-certificado {
    margin-top: 8px;
  }

  .firma-container {
    bottom: 13%;
    right: 30%;
    width: 60px;
  }

  .firma-img {
    max-height: 30px;
  }
}

/* Pantallas grandes */
@media screen and (min-width: 1920px) {
  .contenido-central {
    max-width: 1200px;
    padding-right: 250px;
  }

  .nombre-participante {
    font-size: 52px;
  }

  .a-prefijo {
    font-size: 54px;
  }

  .texto-exitoso {
    font-size: 42px;
  }

  .titulo-capacitacion {
    font-size: 42px;
    margin-bottom: 40px;
  }

  .fecha-certificado {
    font-size: 36px;
    margin-top: 30px;
  }

  .firma-container {
    width: 220px;
  }

  .firma-img {
    max-height: 100px;
  }
}
</style>
